import React from 'react';
import UserName from '@molecules/UserName';
import { IDataGridColumnDescription } from '@models/response/IGridDescriptionResponse';

/**
 * Рендер ячейки ФИО-колонки грида как триггера hover-карточки контактов (UserName) — если у колонки
 * задан userKeyField и в строке есть значение ключа адресной книги. Иначе возвращает null: шаблон
 * рендерит ячейку как раньше (DisplayField), без hover — нулевой регресс.
 *
 * Ключ читается из data.data.fields[userKeyField] (голый key реквизита, БЕЗ префикса 'fields.';
 * бэк кладёт значение ключ-реквизита в строку синтетическим полем). Системный/пустой ключ (0/'0'/'-1'/'')
 * → без hover.
 */
export function createAddressBookCell(
    data: any,
    col?: IDataGridColumnDescription,
    className?: string,
): React.ReactElement | null {
    const keyPath = col?.userKeyField;
    if (!keyPath || data?.rowType !== 'data') {
        return null;
    }
    const rawKey = data?.data?.fields?.[keyPath];
    if (rawKey == null || rawKey === '' || rawKey === 0 || rawKey === '0' || rawKey === '-1') {
        return null;
    }
    // Мультизначение (несколько исполнителей) приходит как "12, 34" — берём первого (основного).
    const userKey = String(rawKey).split(',')[0].trim();
    if (!userKey || userKey === '0' || userKey === '-1') {
        return null;
    }
    return <UserName userKey={userKey} name={data.value} className={className} avatar />;
}
